import { AppointmentMultiple } from 'model/NewMultipleBooking';
import { Waitlist, WaitlistCounts, WaitlistKey, WaitlistsPagination } from 'model/Waitlist';

export interface WaitlistsState {
    loading: boolean;
    waitlists: Array<Waitlist>;
    pagination?: WaitlistsPagination;
    counts?: WaitlistCounts;
    panel: WaitlistsPanelState;
    selected?: Waitlist;
    status: WaitlistsStatus;
    /** Bumped after a create, edit or conversion (and on refresh) so the open list fetches again. */
    listVersion: number;
    /** Add Appointment opened from a waitlist (Convert to Booking). */
    conversion?: WaitlistsConversionState;
}

export interface WaitlistsConversionState {
    waitlist: Waitlist;
    appointments: Array<AppointmentMultiple>;
}

export interface WaitlistsPanelState {
    open: boolean;
    key: WaitlistKey;
    marketplaceIds: Array<number>;
    selectedWaitlistId?: number;
    form?: WaitlistsFormState;
}

export interface WaitlistsFormState {
    /** Undefined when creating a new waitlist. */
    waitlistId?: number;
}

export enum WaitlistsStatus {
    Initial,

    Error,

    FetchStart,
    FetchSuccess,

    GetStart,
    GetSuccess,

    DeleteStart,
    DeleteSuccess
}
